import Ripple from '../../../dumb/Ripple';

const React = require('react');
const map = require('mn-utils/map');
const find = require('mn-utils/find');
const every = require('mn-utils/every');
const reduce = require('mn-utils/reduce');
const IconButton = require('@material-ui/core/IconButton').default;
const AddCircleOutlineIcon
  = require('@material-ui/icons/AddCircleOutline').default;
const {default: ExitToApp} = require("@material-ui/icons/ExitToApp");

const {
  apiAdminTerminalsList,
  apiAdminTerminalsRemove,
  apiAdminTerminalsRemoveAll,
} = require('../../../../api/admin/terminals');
const {
  adminTerminalOpen,
} = require('../../../../emitters/popup');
const {
  confirmRemove,
} = require('../../../../emitters/remove');
const Tooltip = require('../../../dumb/Tooltip/A');
const LayoutA = require('../../../dumb/Layout/A');
const HeaderA = require('../../../dumb/Header/A');
const CaptionA = require('../../../dumb/Caption/A');
const ButtonD = require('../../../dumb/Button/D');
const ButtonUp = require('../../../dumb/Button/Up');
const Popup = require('../../../dumb/Popup/C');

import RowA from '../../../dumb/Row/A';
import ColA2 from '../../../dumb/Col/A2';
import ColA from '../../../dumb/Col/A';
import RowB from '../../../dumb/Row/B';
import ColB from '../../../dumb/Col/B';
import ColB2 from '../../../dumb/Col/B2';
import TrashIcon from '../../../icons/Trash';
import {default as EditIcon} from "@material-ui/icons/Edit";
import {default as LinkIcon} from '@material-ui/icons/InsertLink';
import upperFirst from "mn-utils/upperFirst";
import {getDefaultFilterParams, IntervalFilterAdmin} from "../../../dumb/IntervalFilterCustom";
import withReDelay from "mn-utils/withReDelay";
import {paramStore} from "../../../../stores";
import {apiAdminTerminalsLogoutAllUsers} from "../../../../api/admin/terminals";
import {openPopupWindow, openV1PopupInfo} from "../../../../emitters/popup";

const {
  DisplayIdAdmin,
  DisplayDataAdmin,
} = require("../../../dumb/DisplayData");

const openPopupBind = require('./openPopupBind');

const RowAction = ({title, action, icon: IC, disabled}) => {
  const btn = (
    <IconButton
      className="olN-i (o20):disabled"
      onClick={action}
      disabled={disabled}
    >
      <div className="sq23 layoutRow fhaC fvaC cF">
        {IC && <IC />}
      </div>
    </IconButton>
  )

  return disabled
    ? btn
    : (
      <Tooltip title={title} disabledCopy>
        {btn}
      </Tooltip>
    )
}

const filter$ = paramStore('filter', {});

module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  state: {
    filter: filter$,
  },
  rowHeight: 70,
  request: apiAdminTerminalsList,
  getParams: getDefaultFilterParams,
  wrapper(render, setState, self) {
    // const {
      // handleSortProvider,
      // update,
    // } = self;

    const update = withReDelay(self.update, 1000);

    function handleChangeFilter(filter) {
      filter$.emit({
        ...self.state.filter,
        ...filter,
      });
      update();
    }

    // const handleSortByNameToggle = handleSortProvider('name');
    // const handleSortByBranchNameToggle = handleSortProvider('branch_name');
    // const handleSortByStatusToggle = handleSortProvider('status');
    // const handleSortByColorToggle = handleSortProvider('color');

    function Item({
      data,
    }) {
      const {
        id,
        merchant_id
      } = data;
      // const checkedMap = self.state.checkedMap || {};
      // const checked = checkedMap[id];

      return (
        <RowA className="f12">
          {/*<ColA2 className="w50">*/}
          {/*  <CheckboxB*/}
          {/*    className="c65676D z1"*/}
          {/*    checked={checked}*/}
          {/*    onChange={() => {*/}
          {/*      setState({*/}
          {/*        checkedMap: {*/}
          {/*          ...checkedMap,*/}
          {/*          [id]: !checked,*/}
          {/*        },*/}
          {/*      });*/}
          {/*    }}*/}
          {/*  />*/}
          {/*</ColA2>*/}
          <ColA className="wmin155 fx1">
            <DisplayIdAdmin>
              {data.id}
            </DisplayIdAdmin>
          </ColA>
          <ColA className="wmin100 fx1">
            <DisplayDataAdmin>
              {data.name}
            </DisplayDataAdmin>
          </ColA>
          <ColA className="wmin100 fx1">
            <DisplayDataAdmin>
              {data.login}
            </DisplayDataAdmin>
          </ColA>
          <ColA className="wmin100 fx1">
            <DisplayDataAdmin>
              {data.company_name}
            </DisplayDataAdmin>
          </ColA>
          <ColA className="wmin100">
            <DisplayDataAdmin>
              {data.password}
            </DisplayDataAdmin>
          </ColA>
          <ColA className="wmin100">
            <DisplayDataAdmin>
              {data.color}
            </DisplayDataAdmin>
          </ColA>
          <ColA className="wmin100">
            {data.status ? upperFirst(data.status) : ''}
          </ColA>
          <ColA2 className="w56">
            <RowAction
              title="Bind Terminal"
              action={() => openPopupBind({
                id,
                merchant_id,
                password: data.password,
                update
              })}
              icon={LinkIcon}
            />
          </ColA2>
          <ColA2 className="w56">
            <RowAction
              title="Edit"
              action={() => (
                adminTerminalOpen({
                  id,
                  callback: update,
                })
              )}
              icon={EditIcon}
            />
          </ColA2>
          <ColA2 className="w56">
            <RowAction
              title="Delete"
              action={() => {
                confirmRemove(() => {
                  setState({
                    loading: true,
                  });
                  apiAdminTerminalsRemove({
                    id,
                  }).finally((error) => {
                    const data = self.state.data || {};
                    const items = data.list || [];
                    const _state = {
                      error,
                      loading: false,
                    };
                    error || (_state.data = {
                      list: items.filter((v) => v.id !== id),
                      count: data.count - 1,
                    });
                    setState(_state);
                    update();
                  });
                });
              }}
              icon={TrashIcon}
            />
          </ColA2>
          <ColA2 className="w56">
            <RowAction
              title="Logout all users"
              action={() => {
                return openPopupWindow((setPopupState, popup) => {
                  return (stateOfPopup) => {
                    return (
                      <Popup
                        caption={(
                          <div className="layoutRow fhaS fvaC w">
                            <div>Log all users out</div>
                          </div>
                        )}
                        disabled={stateOfPopup.clicked}
                        onCancel={popup.close}
                        // disabled={stateOfPopup.clicked && invalidAssetAmount}
                        text="Yes"
                        onSave={() => {
                          setPopupState({loading: true});

                          return apiAdminTerminalsLogoutAllUsers({id})
                              .then(() => {
                                update();
                                openV1PopupInfo([`All users were logged out from the terminal ${id}`]);
                                popup.close();
                              })
                              .catch(() => {
                                setPopupState({loading: false});
                              })
                        }}
                      >
                        <div className="mt15">
                          Would you like to logout all users from the terminal id?
                        </div>
                      </Popup>
                    )
                  }
                })
              }}
              icon={ExitToApp}
            />
          </ColA2>
        </RowA>
      );
    }

    return (state) => {
      const filter = state.filter;

      // Legacy part for checkbox

      // const data = state.data || {};
      // const items = data.list || [];
      // const checkedMap = state.checkedMap || {};

      // const hasActiveAny = find(items, isChecked);
      const hasActiveAny = false;
      // const hasActiveAll = every(items, isChecked);
      // const selectedIds = map(items.filter(isChecked), 'id');

      // function isChecked(item) {
      //   return checkedMap[item.id];
      // }
      // function handlerCheckAll() {
      //   setState({
      //     checkedMap: reduce(items, (output, item) => {
      //       output[item.id] = !hasActiveAll;
      //       return output;
      //     }, {}),
      //   });
      // }


      return (
        <LayoutA>
          <HeaderA className="mr-15">
            <CaptionA>mPOS Terminals</CaptionA>
            <ButtonD
              onClick={() => {
                adminTerminalOpen({
                  id: 'new',
                  callback: update,
                });
              }}
            >
              <AddCircleOutlineIcon/>
              <div className="pl15">Add terminal</div>
            </ButtonD>
          </HeaderA>
          <IntervalFilterAdmin
            className="mt16"
            data={filter}
            onChange={handleChangeFilter}
            search={{
              className: 'w330',
              placeholder: 'Search by ID / Email / Name',
            }}
            hideTimeInterval
          />
          <div className="rlv h100vh-380 mh-45">
            <div className="ovxA abs s ph45">
              <div className="wmin1200 rlv h">
                <div>
                  <RowB
                    className={`f12 h66 ph50 pl40 r6 dn bg0.1.active h70 w100%+90 bc505255 cA4A7AC dn bc00.active` + (hasActiveAny ? ' active' : '')}
                  >
                    {/*<ColB2 className="mA>1 w50 ph0*2">*/}
                    {/*  <CheckboxB*/}
                    {/*    className="c65676D"*/}
                    {/*    checked={hasActiveAll}*/}
                    {/*    onChange={handlerCheckAll}*/}
                    {/*  />*/}
                    {/*</ColB2>*/}
                    <ColB className="wmin155 fx1">ID</ColB>
                    <ColB className="wmin100 fx1">Name</ColB>
                    <ColB className="wmin100 fx1">Email</ColB>
                    <ColB className="wmin100 fx1">Company</ColB>
                    <ColB className="wmin100">Code</ColB>
                    <ColB className="wmin100">Color</ColB>
                    <ColB className="wmin100">Status</ColB>
                    <ColB2 className="w56" />
                    <ColB2 className="w56" />
                    <ColB2 className="w56" />
                    <ColB2 className="w56" />
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
            {/*<div className={*/}
            {/*  'w100%-380 h90 fixed sb0 sl355 layoutRow jcSB aiC ph25 rlt16 rrt16 bg04 xY100% dn (xY0).shown'*/}
            {/*  + (!!selectedIds.length ? ' shown' : '')*/}
            {/*}>*/}
            {/*  <div>{selectedIds.length} selected</div>*/}
            {/*  <div>*/}
            {/*    <Tooltip title="Delete" disabledCopy>*/}
            {/*      <Ripple*/}
            {/*        className="w40 h40 p7 r7 (bgc0.25):h"*/}
            {/*        onClick={() => {*/}
            {/*          confirmRemove(() => {*/}
            {/*            setState({*/}
            {/*              loading: true,*/}
            {/*            });*/}
            {/*            apiAdminTerminalsRemoveAll({*/}
            {/*              ids: selectedIds,*/}
            {/*            }).finally((error) => {*/}
            {/*              const _state = {*/}
            {/*                error,*/}
            {/*              };*/}
            {/*              error || (_state.data = {*/}
            {/*                list: items.filter((v) => {*/}
            {/*                  return selectedIds.indexOf(v.id) === -1;*/}
            {/*                }),*/}
            {/*                count: data.count - selectedIds.length,*/}
            {/*              });*/}
            {/*              setState(_state);*/}
            {/*              update();*/}
            {/*            });*/}
            {/*          });*/}
            {/*        }}*/}
            {/*      >*/}
            {/*        <TrashIcon className="w25 h25"/>*/}
            {/*      </Ripple>*/}
            {/*    </Tooltip>*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>
        </LayoutA>
      );
    };
  },
});
